export class Price {
  includingVAT: number;
  excludingVAT: number;
  vatPercentage: number;

  constructor(includingVAT?: number, excludingVAT?: number, vatPercentage?: number) {
    this.includingVAT = includingVAT || 0;
    this.excludingVAT = excludingVAT || 0;
    this.vatPercentage = vatPercentage || 0;
  }
}

export enum PriceInformationPaymentType {
  Unknown = 'Unknown',
  OneTime = 'OneTime',
  Monthly = 'Monthly',
}

export class PriceInformation {
  paymentType?: PriceInformationPaymentType;
  recurringLength?: number;
  price?: Price;
  totalPrice?: Price;
  isDiscounted?: boolean;
  discountName?: string;
  discountLength?: number;
  originalPrice?: Price;
  discountAmount?: Price;
  discountPercentage?: number;
}
